// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refund-requests .highlighted-row {
  background-color: #ffd591;
  transition: background-color 0.3s ease;
}
.refund-requests .highlighted-row:hover {
  background-color: #ffc069;
}
.refund-requests .ant-table {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}
.refund-requests .ant-table .ant-table-container {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
}
.refund-requests .ant-table .ant-table-thead > tr > th {
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  text-align: center;
  font-weight: 500;
}
.refund-requests .ant-table .ant-table-tbody > tr > td {
  border: 1px solid #f0f0f0;
}
.refund-requests .ant-table .ant-table-row {
  transition: background-color 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/pages/RefundRequests/styles.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,sCAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAIE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAII;EACE,yBAAA;EACA,kBAAA;AAFN;AAKI;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAHN;AAMI;EACE,yBAAA;AAJN;AAOI;EACE,sCAAA;AALN","sourcesContent":[".refund-requests {\n  .highlighted-row {\n    background-color: #ffd591;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background-color: #ffc069;\n    }\n  }\n\n  .ant-table {\n    border: 1px solid #f0f0f0;\n    border-radius: 8px;\n    overflow: hidden;\n\n    .ant-table-container {\n      border: 1px solid #f0f0f0;\n      border-radius: 8px;\n    }\n\n    .ant-table-thead > tr > th {\n      background-color: #fafafa;\n      border: 1px solid #f0f0f0;\n      text-align: center;\n      font-weight: 500;\n    }\n\n    .ant-table-tbody > tr > td {\n      border: 1px solid #f0f0f0;\n    }\n\n    .ant-table-row {\n      transition: background-color 0.3s ease;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
